const thresholds = [
  { size: 5, value: 'large' },
  { size: 8, value: 'medium' },
];
const DEFAULT = 'small';
const getTextSize = ([threshold, ...rest]) => (length) => {
  if (Boolean(threshold)) {
    return length <= threshold.size ? threshold.value : getTextSize(rest)(length);
  }
  else {
    return DEFAULT;
  }
};
export const getPointsSize = getTextSize(thresholds.sort((first, second) => first.size - second.size));
//# sourceMappingURL=fnx-pricing-points.utils.js.map
